var _g, _g2, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.42
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.74713 6.6021H7.6057V6.74353V10.187V10.3284H7.74713H16.3558H16.4973V10.187V6.74353V6.6021H16.3558H7.74713ZM7.74713 11.7673H7.6057V11.9087V13.6305V13.7719H7.74713H9.46887H9.6103V13.6305V11.9087V11.7673H9.46887H7.74713ZM11.1906 11.7673H11.0492V11.9087V13.6305V13.7719H11.1906H12.9123H13.0538V13.6305V11.9087V11.7673H12.9123H11.1906ZM14.6341 11.7673H14.4927V11.9087V13.6305V13.7719H14.6341H16.3558H16.4973V13.6305V11.9087V11.7673H16.3558H14.6341ZM7.74713 15.2108H7.6057V15.3522V17.074V17.2154H7.74713H9.46887H9.6103V17.074V15.3522V15.2108H9.46887H7.74713ZM11.1906 15.2108H11.0492V15.3522V17.074V17.2154H11.1906H12.9123H13.0538V17.074V15.3522V15.2108H12.9123H11.1906ZM14.6341 15.2108H14.4927V15.3522V17.074V17.2154H14.6341H16.3558H16.4973V17.074V15.3522V15.2108H16.3558H14.6341ZM7.74713 18.6543H7.6057V18.7957V20.5174V20.6589H7.74713H9.46887H9.6103V20.5174V18.7957V18.6543H9.46887H7.74713ZM11.1906 18.6543H11.0492V18.7957V20.5174V20.6589H11.1906H12.9123H13.0538V20.5174V18.7957V18.6543H12.9123H11.1906ZM14.6341 18.6543H14.4927V18.7957V20.5174V20.6589H14.6341H16.3558H16.4973V20.5174V18.7957V18.6543H16.3558H14.6341ZM7.74713 5.16322H16.3558C16.7749 5.16322 17.1769 5.32971 17.4733 5.62608C17.7696 5.92245 17.9361 6.3244 17.9361 6.74353V20.5174C17.9361 20.9366 17.7696 21.3385 17.4733 21.6349C17.1769 21.9313 16.7749 22.0978 16.3558 22.0978H7.74713C7.32801 22.0978 6.92605 21.9313 6.62968 21.6349C6.33332 21.3385 6.16682 20.9366 6.16682 20.5174V6.74353C6.16682 6.3244 6.33332 5.92245 6.62968 5.62608C6.92605 5.32971 7.32801 5.16322 7.74713 5.16322Z",
    fill: "url(#paint0_linear_931_372)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74713 6.6021H7.6057V6.74353V10.187V10.3284H7.74713H16.3558H16.4973V10.187V6.74353V6.6021H16.3558H7.74713ZM7.74713 11.7673H7.6057V11.9087V13.6305V13.7719H7.74713H9.46887H9.6103V13.6305V11.9087V11.7673H9.46887H7.74713ZM11.1906 11.7673H11.0492V11.9087V13.6305V13.7719H11.1906H12.9123H13.0538V13.6305V11.9087V11.7673H12.9123H11.1906ZM14.6341 11.7673H14.4927V11.9087V13.6305V13.7719H14.6341H16.3558H16.4973V13.6305V11.9087V11.7673H16.3558H14.6341ZM7.74713 15.2108H7.6057V15.3522V17.074V17.2154H7.74713H9.46887H9.6103V17.074V15.3522V15.2108H9.46887H7.74713ZM11.1906 15.2108H11.0492V15.3522V17.074V17.2154H11.1906H12.9123H13.0538V17.074V15.3522V15.2108H12.9123H11.1906ZM14.6341 15.2108H14.4927V15.3522V17.074V17.2154H14.6341H16.3558H16.4973V17.074V15.3522V15.2108H16.3558H14.6341ZM7.74713 18.6543H7.6057V18.7957V20.5174V20.6589H7.74713H9.46887H9.6103V20.5174V18.7957V18.6543H9.46887H7.74713ZM11.1906 18.6543H11.0492V18.7957V20.5174V20.6589H11.1906H12.9123H13.0538V20.5174V18.7957V18.6543H12.9123H11.1906ZM14.6341 18.6543H14.4927V18.7957V20.5174V20.6589H14.6341H16.3558H16.4973V20.5174V18.7957V18.6543H16.3558H14.6341ZM7.74713 5.16322H16.3558C16.7749 5.16322 17.1769 5.32971 17.4733 5.62608C17.7696 5.92245 17.9361 6.3244 17.9361 6.74353V20.5174C17.9361 20.9366 17.7696 21.3385 17.4733 21.6349C17.1769 21.9313 16.7749 22.0978 16.3558 22.0978H7.74713C7.32801 22.0978 6.92605 21.9313 6.62968 21.6349C6.33332 21.3385 6.16682 20.9366 6.16682 20.5174V6.74353C6.16682 6.3244 6.33332 5.92245 6.62968 5.62608C6.92605 5.32971 7.32801 5.16322 7.74713 5.16322Z",
    fill: "#7595B2",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74713 6.6021H7.6057V6.74353V10.187V10.3284H7.74713H16.3558H16.4973V10.187V6.74353V6.6021H16.3558H7.74713ZM7.74713 11.7673H7.6057V11.9087V13.6305V13.7719H7.74713H9.46887H9.6103V13.6305V11.9087V11.7673H9.46887H7.74713ZM11.1906 11.7673H11.0492V11.9087V13.6305V13.7719H11.1906H12.9123H13.0538V13.6305V11.9087V11.7673H12.9123H11.1906ZM14.6341 11.7673H14.4927V11.9087V13.6305V13.7719H14.6341H16.3558H16.4973V13.6305V11.9087V11.7673H16.3558H14.6341ZM7.74713 15.2108H7.6057V15.3522V17.074V17.2154H7.74713H9.46887H9.6103V17.074V15.3522V15.2108H9.46887H7.74713ZM11.1906 15.2108H11.0492V15.3522V17.074V17.2154H11.1906H12.9123H13.0538V17.074V15.3522V15.2108H12.9123H11.1906ZM14.6341 15.2108H14.4927V15.3522V17.074V17.2154H14.6341H16.3558H16.4973V17.074V15.3522V15.2108H16.3558H14.6341ZM7.74713 18.6543H7.6057V18.7957V20.5174V20.6589H7.74713H9.46887H9.6103V20.5174V18.7957V18.6543H9.46887H7.74713ZM11.1906 18.6543H11.0492V18.7957V20.5174V20.6589H11.1906H12.9123H13.0538V20.5174V18.7957V18.6543H12.9123H11.1906ZM14.6341 18.6543H14.4927V18.7957V20.5174V20.6589H14.6341H16.3558H16.4973V20.5174V18.7957V18.6543H16.3558H14.6341ZM7.74713 5.16322H16.3558C16.7749 5.16322 17.1769 5.32971 17.4733 5.62608C17.7696 5.92245 17.9361 6.3244 17.9361 6.74353V20.5174C17.9361 20.9366 17.7696 21.3385 17.4733 21.6349C17.1769 21.9313 16.7749 22.0978 16.3558 22.0978H7.74713C7.32801 22.0978 6.92605 21.9313 6.62968 21.6349C6.33332 21.3385 6.16682 20.9366 6.16682 20.5174V6.74353C6.16682 6.3244 6.33332 5.92245 6.62968 5.62608C6.92605 5.32971 7.32801 5.16322 7.74713 5.16322Z",
    stroke: "#142B2B",
    strokeWidth: 0.282857
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.373,
    y: 13.6305,
    width: 1.2913,
    height: 11.6217,
    fill: "#3BBB57"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2913,
    height: 1.86522,
    transform: "matrix(-1 0 0 1 13.3438 24.6783)",
    fill: "#3BBB57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.3809,
    y: 12.7696,
    width: 1.2913,
    height: 5.3087,
    fill: "#3BBB57"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2913,
    height: 5.3087,
    transform: "matrix(-1 0 0 1 11.334 23.8174)",
    fill: "#3BBB57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.2109,
    y: 22.2391,
    width: 1.2913,
    height: 2.0087,
    fill: "#3BBB57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.1211,
    y: 11.1913,
    width: 1.2913,
    height: 9.61304,
    fill: "#3BBB57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.8438,
    y: 6.74347,
    width: 1.2913,
    height: 4.73478,
    fill: "#3BBB57"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2913,
    height: 3.73044,
    transform: "matrix(-1 0 0 1 5.5957 22.2391)",
    fill: "#3BBB57"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2913,
    height: 5.3087,
    transform: "matrix(-1 0 0 1 3.44141 19.3696)",
    fill: "#3BBB57"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.248,
    y: 15.4957,
    width: 1.2913,
    height: 5.3087,
    fill: "#FF5959"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2913,
    height: 5.3087,
    transform: "matrix(-1 0 0 1 9.46875 26.5435)",
    fill: "#FF5959"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.1133,
    y: 19.9435,
    width: 1.2913,
    height: 2.15217,
    fill: "#FF5959"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.2207,
    y: 23.2435,
    width: 1.2913,
    height: 5.3087,
    fill: "#FF5959"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.2031,
    y: 23.2435,
    width: 1.2913,
    height: 3.3,
    fill: "#FF5959"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.2913,
    height: 2.15217,
    transform: "matrix(-1 0 0 1 7.46094 25.9696)",
    fill: "#FF5959"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.471429,
    y: 0.471429,
    width: 32.0571,
    height: 32.0571,
    rx: 7.07143,
    stroke: "#3D5461",
    strokeWidth: 0.942857
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_931_372",
    x1: 6.02539,
    y1: 5.02179,
    x2: 18.0662,
    y2: 23.7671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5894D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10DEB9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.00edfb4426e86bbefe4afc524544d0d9.svg";
export { ForwardRef as ReactComponent };